import React from "react";
import { useEffect, useRef } from "react";

const VideoInstitucional = () => {
  const videoRef = useRef(null);

  useEffect(() => {
    const video = videoRef.current;
    if (video) {
      video.play();
    }
  }, []);

  return (
    <video
      ref={videoRef}
      src="../video/sociedaditaliana.mp4" // Reemplaza con la ruta del video
      autoPlay
      muted
      loop
      playsInline
      style={{ width: "100%", height: "auto" }}
      disablePictureInPicture
      controlsList="nodownload nofullscreen noplaybackrate"
      onContextMenu={(e) => e.preventDefault()}
    />
  );
};

export default VideoInstitucional;